import { axiosAjax } from '@app/src/config/axios';
import { TypePublicationModel } from '@app/src/views/StepTwo/channelPublication/models/typePublication';
import { hydrateData } from './hydrators';
import { CATEGORIES, CATEGORY, CATEGORY_ALIAS } from '@app/src/config/categories';
import { isClientEnv } from '@app/src/utils/validations';

export const typePublicationService = {
  async get(categoryId: number, operationId?: number, idOwnInput?: number): Promise<TypePublicationModel[]> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      let response = null;
      const configs = CATEGORIES[CATEGORY[categoryId]];
      switch (configs && configs.alias) {
        case CATEGORY_ALIAS.OPORTUNIDAD:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_OPPORTUNITY
              .replace(':categoryId', '' + categoryId)
              .replace(':operationId', '' + operationId)
              .replace(':sectionId', '' + idOwnInput),
              config
          );
          break;
        case CATEGORY_ALIAS.INMUEBLE:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_PROPERTY
              .replace(':categoryId', '' + categoryId)
              .replace(':operationId', '' + operationId)
              .replace(':propertyId', '' + idOwnInput),
              config
          );
          break;
        case CATEGORY_ALIAS.VEHICULO:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_VEHICLE
              .replace(':categoryId', '' + categoryId)
              .replace(':operationId', '' + operationId)
              .replace(':vehicleId', '' + idOwnInput),
              config
          );
          break;
        case CATEGORY_ALIAS.EDUCACION:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_EDUCATION
              .replace(':categoryId', '' + categoryId)
              .replace(':operationId', '' + operationId),
              config
          );
          break;
        default:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION
              .replace(':categoryId', '' + categoryId),
              config
          );
      }

      const { data } = response;

      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async getAvailable(userId: number, categoryId: number, packageId: number, operationId?: number, idOwnInput?: number): Promise<TypePublicationModel[]> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      let response = null;
      const configs = CATEGORIES[CATEGORY[categoryId]];
      switch (configs && configs.alias) {
        case CATEGORY_ALIAS.OPORTUNIDAD:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_CONSUME_OPPORTUNITY
              .replace(':userId', '' + userId)
              .replace(':categoryId', '' + categoryId)
              .replace(':packageId', '' + packageId)
              .replace(':operationId', '' + operationId)
              .replace(':sectionId', '' + idOwnInput),
              config
          );
          break;
        case CATEGORY_ALIAS.INMUEBLE:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_CONSUME_PROPERTY
              .replace(':userId', '' + userId)
              .replace(':categoryId', '' + categoryId)
              .replace(':packageId', '' + packageId)
              .replace(':operationId', '' + operationId)
              .replace(':propertyId', '' + idOwnInput),
              config
          );
          break;
        case CATEGORY_ALIAS.VEHICULO:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_CONSUME_VEHICLE
              .replace(':userId', '' + userId)
              .replace(':categoryId', '' + categoryId)
              .replace(':packageId', '' + packageId)
              .replace(':operationId', '' + operationId)
              .replace(':vehicleId', '' + idOwnInput),
              config
          );
          break;
        case CATEGORY_ALIAS.EDUCACION:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_CONSUME_EDUCATION
              .replace(':userId', '' + userId)
              .replace(':categoryId', '' + categoryId)
              .replace(':packageId', '' + packageId)
              .replace(':operationId', '' + operationId),
              config
          );
          break;
        default:
          response = await axiosAjax.get(
            process.env.API_PUBLICATION_CONSUME
              .replace(':userId', '' + userId)
              .replace(':categoryId', '' + categoryId)
              .replace(':packageId', '' + packageId),
              config
          );
      }

      const { data } = response;

      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
};
